/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaAttributoEsercenteValoreDTO } from '../model/models';
import { TipoPraticaAttributoEsercenteValoreCreationForm } from '../model/models';
import { TipoPraticaAttributoEsercenteValoreDTO } from '../model/models';
import { TipoPraticaAttributoEsercenteValorePatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaAttributoEsercenteValoreRequestParams {
    idTipoPratica: string;
    idAttr: string;
    tipoPraticaAttributoEsercenteValoreCreationForm: TipoPraticaAttributoEsercenteValoreCreationForm;
}

export interface DeleteTipoPraticaAttributoEsercenteValoreRequestParams {
    idTipoPratica: string;
    idAttr: string;
    idVal: string;
}

export interface GetTipoPraticaAttributoEsercenteValoreRequestParams {
    idTipoPratica: string;
    idAttr: string;
    idVal: string;
}

export interface ListTipoPraticaAttributoEsercenteValoriRequestParams {
    idTipoPratica: string;
    idAttr: string;
    pageable: Pageable;
}

export interface UpdateTipoPraticaAttributoEsercenteValoreRequestParams {
    idTipoPratica: string;
    idAttr: string;
    idVal: string;
    tipoPraticaAttributoEsercenteValorePatchForm: TipoPraticaAttributoEsercenteValorePatchForm;
}


export interface TipoPraticaAttributoEsercenteValoriControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea una nuova opzione catalogata dell\&#39;attributo esercente (CUSTOM_SINGLE_CHOICE / CUSTOM_MULTIPLE_CHOICE)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori
* @param requestParameters
     */
    createTipoPraticaAttributoEsercenteValore(requestParameters: CreateTipoPraticaAttributoEsercenteValoreRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoEsercenteValoreDTO>;

    /**
     * Elimina una opzione dell\&#39;attributo esercente
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori/{idVal}
* @param requestParameters
     */
    deleteTipoPraticaAttributoEsercenteValore(requestParameters: DeleteTipoPraticaAttributoEsercenteValoreRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di una opzione per id (path consistency: 404 se la chain è rotta)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori/{idVal}
* @param requestParameters
     */
    getTipoPraticaAttributoEsercenteValore(requestParameters: GetTipoPraticaAttributoEsercenteValoreRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoEsercenteValoreDTO>;

    /**
     * Lista paginata delle opzioni dell\&#39;attributo esercente (sort default: ordine, id ASC)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori
* @param requestParameters
     */
    listTipoPraticaAttributoEsercenteValori(requestParameters: ListTipoPraticaAttributoEsercenteValoriRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaAttributoEsercenteValoreDTO>;

    /**
     * Replace di una opzione (richiede version; value frozen post-pubblicazione)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori/{idVal}
* @param requestParameters
     */
    updateTipoPraticaAttributoEsercenteValore(requestParameters: UpdateTipoPraticaAttributoEsercenteValoreRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoEsercenteValoreDTO>;

}
